export const getActiveMenuPath = (pathname: string, permissionKeys: string[]) =>
  permissionKeys
    .filter((p) => pathname === p || pathname.startsWith(p))
    .sort((a, b) => b.length - a.length)[0];
